export default {
  allCell: {
    width: '60px'
  },
  all: {
    width: '30px'
  },
  dateCell: {
    width: '120px',
    textAlign: 'left'
  },
  date: {
    width: '40px'
  },
  title: {
    width: '50px'
  },
  titleCell: {
    textAlign: 'left'
  },
  contributorsCell: {
    textAlign: 'center',
    width: '145px'
  },
  conclusionCell: {
    width: '120px'
  },
  conclusion: {
    width: '80px'
  },
  contextMenuCell: {
    width: '93px'
  },
  bulkAction: {
    display: 'block',
    height: '40px',
    width: '93px',
    borderRadius: '4px'
  }
}
